Theme.ComponentCollections.MenuDropdowns = (function () {
  const collection = new Theme.ComponentCollection("component-menu-dropdown");

  hide_on_click();
  hide_on_scroll();
  hide_on_resize();

  function hide_on_click() {
    document.addEventListener("click", (event) => {
      if (!event.target.closest("component-menu-dropdown")) {
        hide();
      }
    });
  }

  function hide_on_scroll() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          hide();
        }
      });
    }, { threshold: 0.1 });

    collection.elements.forEach(element => {
      observer.observe(element);
    });
  }

  function hide_on_resize() {
    const mediaQuery = window.matchMedia("(max-width: 1023px)");

    mediaQuery.addEventListener("change", (event) => {
      if (event.matches) {
        hide();
      }
    });
  }

  function hide(options) {
    const except = options && options.except;

    collection.elements.forEach(element => {
      if (element !== except) {
        element.hide();
      }
    });
  }

  return {
    hide
  }
})();

class ComponentMenuDropdown extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      "dropdown": ".menu-dropdown"
    });

    this.collection = Theme.ComponentCollections.MenuDropdowns;
  }

  connectedCallback() {
    this.events();
    this.onMegamenuClick = this.onMegamenuClick.bind(this);
    document.addEventListener("megamenu:click", this.onMegamenuClick);

    this.addEventListener("mouseenter", () => {
      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    });

    this.addEventListener("mouseleave", (e) => {
      if (!this.contains(e.relatedTarget)) {
        setTimeout(() => {
          if (!this.matches(":hover")) this.hide();
        }, 150);
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener("megamenu:click", this.onMegamenuClick);
  }

  onMegamenuClick() {
    if (this.classList.contains("active--true")) {
      this.hide();
    } else {
      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    }
  }

  toggle() {
    if (this.classList.contains("active--true")) {
      this.hide();
    } else {
      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    }
  }

hide() {
  if (!this.classList.contains("active--true")) {
    return;
  }

  this.classList.remove("active--true");

  const nav = document.querySelector(".navigation");
  if (nav) nav.classList.remove("navigation--dropdown-active");

  this.elements.dropdown.addEventListener("transitionend", () => {
  }, { once: true });
}

  show() {
    return new Promise(resolve => {
      requestAnimationFrame(() => {
        this.classList.add("active--true");

        const nav = document.querySelector(".navigation");
        if (nav) nav.classList.add("navigation--dropdown-active");

        setTimeout(() => {
          resolve();
        }, 150);
      });
    });
  }
}

customElements.define("component-menu-dropdown", ComponentMenuDropdown);